<script setup lang="ts">
import type { BadgePaymentServiceProps } from '../types/interfaces'

import { useBadgePaymentService } from '../composables/badge-payment-service.hook'
import { AppBadge } from '../../app-badge'

defineOptions({
  name: 'BadgePaymentService',
})

const props = defineProps<BadgePaymentServiceProps>()

const {
  color,
  text,
} = useBadgePaymentService({ props })
</script>

<template>
  <AppBadge
    :color="color"
    :text="text"
  />
</template>
